export enum UserActionTypes {
  API_RESPONSE_SUCCESS = "@@users/API_RESPONSE_SUCCESS",
  API_RESPONSE_ERROR = "@@users/API_RESPONSE_ERROR",

  GET_USER_DATA = "@@users/GET_USER_DATA",
  ACTIVATE_USER = "@@users/ACTIVATE_USER",
  BLOCK_USER = "@@users/BLOCK_USER",
}
